import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const RAW_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_BASE = (RAW_URL && RAW_URL !== "undefined" && !RAW_URL.includes("localhost"))
    ? RAW_URL.replace(/\/$/, "")
    : "https://portfolio-backend-5fz0.onrender.com";

const API = `${BACKEND_BASE}/api`;

export const api = axios.create({ baseURL: API });

export const endpoints = {
    config: () => api.get("/config").then((r) => r.data),
    content: (t) => api.get(`/content/${t}`).then((r) => r.data),
    github: () => api.get("/github/stats").then((r) => r.data),
    contact: (data) => api.post("/contact", data).then((r) => r.data),
    visitors: () => api.post("/visitors").then((r) => r.data),
    login: (password) => api.post("/admin/login", { password }).then((r) => r.data),
};

export const adminApi = (token) => {
    const inst = axios.create({ baseURL: API, headers: { Authorization: `Bearer ${token}` } });
    return {
        createContent: (t, data) => inst.post(`/admin/content/${t}`, { data }).then((r) => r.data),
        updateContent: (t, id, data) => inst.put(`/admin/content/${t}/${id}`, { data }).then((r) => r.data),
        deleteContent: (t, id) => inst.delete(`/admin/content/${t}/${id}`).then((r) => r.data),
        updateConfig: (data) => inst.put(`/admin/config`, data).then((r) => r.data),
        contacts: () => inst.get(`/admin/contacts`).then((r) => r.data),
        deleteContact: (id) => inst.delete(`/admin/contacts/${id}`).then((r) => r.data),
        markRead: (id) => inst.post(`/admin/contacts/${id}/read`).then((r) => r.data),
    };
};

// ---------- Theme ----------
const ThemeCtx = createContext({ theme: "dark", toggle: () => { } });
export const useTheme = () => useContext(ThemeCtx);

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "dark");
    useEffect(() => {
        const root = document.documentElement;
        root.classList.toggle("dark", theme === "dark");
        localStorage.setItem("theme", theme);
    }, [theme]);
    const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
    return <ThemeCtx.Provider value={{ theme, toggle }}>{children}</ThemeCtx.Provider>;
}

// ---------- Data hook ----------
export function usePortfolioData() {
    const [data, setData] = useState({ config: null, projects: [], skills: [], experience: [], education: [], certifications: [], achievements: [], testimonials: [], blogs: [], github: null, loading: true });
    useEffect(() => {
        let active = true;
        (async () => {
            try {
                const [config, projects, skills, experience, education, certifications, achievements, testimonials, blogs] = await Promise.all([
                    endpoints.config(), endpoints.content("projects"), endpoints.content("skills"),
                    endpoints.content("experience"), endpoints.content("education"), endpoints.content("certifications"),
                    endpoints.content("achievements"), endpoints.content("testimonials"), endpoints.content("blogs"),
                ]);
                if (!active) return;
                setData((d) => ({ ...d, config, projects, skills, experience, education, certifications, achievements, testimonials, blogs, loading: false }));
                endpoints.github().then((github) => active && setData((d) => ({ ...d, github }))).catch(() => { });
                endpoints.visitors().catch(() => { });
            } catch (e) {
                if (active) setData((d) => ({ ...d, loading: false }));
            }
        })();
        return () => { active = false; };
    }, []);
    return data;
}
